import React from "react";
import "./ReviewCustomers.css";
import ReviewCutomer from "./ReviewCutomer";
import img1 from "../../../Images/ReviewCustomer/review-1.png";
import img2 from "../../../Images/ReviewCustomer/review-2.png";
import img3 from "../../../Images/ReviewCustomer/review-3.png";
import ReviewSlider from "./ReviewSlider";

const ReviewCutomers = () => {
  const reviews = [
    {
      _id: 1,
      designation: "Product Designer",
      name: "Shalima Hayden",
      description:
        "Interface Solutions Limited, as business integrators, reviewed my company processes and helped resolve complex business difficulties using technology.",
      img: img1,
    },
    {
      _id: 2,
      designation: "Business Director",
      name: "Clay Johnson",
      description:
        "ISL Solutions was my go-to for EAS-related services. ISL provided me with Corporate Application Services (EAS), which includes design, installation.",
      img: img2,
    },
    {
      _id: 3,
      designation: "Product Designer",
      name: "Data center Solution",
      description:
        "Make the appearance of a mobile application that has quality and increases user convenience, and production support services.",
      img: img3,
    },
  ];
  return (
    <div className="review-full-div container">
      <div>
        <h5 className="testimonial-h5">TESTIMONIALS</h5>
        <h1 className="testimonial-h1">What Our Customer says</h1>
        <p className="testimonial-p">
          Find out why our customers are raving about our products and services
          - read our reviews
        </p>
      </div>
      <div className="review-map">
        {reviews.map((review) => (
          <ReviewCutomer key={review._id} review={review}></ReviewCutomer>
        ))}
      </div>
      <div className="ReviewCustomerSlider">
        <ReviewSlider />
      </div>
    </div>
  );
};

export default ReviewCutomers;
